
















import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
    props: {
        icon: { type: String, required: true },
        status: { type: String, default: "" },
        statusCss: { type: String, default: "statusText" },
        paired: { type: Boolean, default: null }
    },
    setup(props) {
        const iconSrc = computed(() => {
            return require(`@/assets/icons/${props.icon}.svg`);
        });
        const withStatus = computed(() => {
            return props.status !== "";
        });
        return {
            iconSrc,
            withStatus
        };
    }
});
